import { reactive, shallowRef } from "vue"

class DrawerService {
  state = reactive({
    visible: false,
    content: null,
    isRawHtml: false,
    options: { position: "right" }
  })

  open(content, options = {}) {
    if (typeof content === "string") {
      this.state.isRawHtml = true
      this.state.content = content
    } else {
      this.state.isRawHtml = false
      this.state.content = shallowRef(content)
    }
    this.state.options = { ...this.state.options, ...options }
    this.state.visible = true
  }

  close() {
    this.state.visible = false
    this.state.content = null
    this.state.options = { position: "right" }
  }
}

export default {
  install(app) {
    const drawerService = new DrawerService()

    app.provide("drawerService", drawerService)
  }
}
